import React, { Component } from 'react';
// import 'antd/dist/antd.css';
import './App.css';
import { Button, Col, Layout, message, Popconfirm, Row, Tooltip } from 'antd';
import BOForm from './components/BOForm';
import NewBOModal from './components/modals/NewBOModal';
import { AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import { v4 as uuidv4 } from 'uuid';
import EditBOModal from './components/modals/EditBOModal';
import { submitForm } from './utils';

const { Content, } = Layout;

class App extends Component {
  constructor(props) {
    super(props)
    this.childBOFOrm = React.createRef();
    this.state = {
      defaultBOColumns: [
        {
          title: 'SURNAME',
          dataIndex: 'boSurname',
          width: '30%',
          editable: true,
          responsive: ['xs', 'sm', 'md', 'lg'],
        },
        {
          title: 'FIRST NAME',
          dataIndex: 'boFirstName',
          width: '30%',
          editable: true,
          responsive: ['xs', 'sm', 'md', 'lg'],
        },
        {
          title: 'NIC/PASSPORT NO',
          dataIndex: 'boNIC',
          width: '10%',
          responsive: ['lg'],
        },
        {
          title: 'NATIONALITY',
          dataIndex: 'boNationality',
          width: '10%',
          responsive: ['lg'],
        },
        {
          title: 'PERMANENT CURRENT RESIDENTIAL ADDRESS',
          dataIndex: 'boAddress',
          width: '30%',
          responsive: ['lg'],
        },
        {
          title: 'CONTROLLING OWNERSHIP INTEREST (%)',
          dataIndex: 'boInterestPercent',
          width: '3%',
          responsive: ['xs', 'sm', 'md', 'lg'],
        },
        {
          title: ' ',
          dataIndex: 'operation',
          responsive: ['xs', 'sm', 'md', 'lg'],
          width: '18%',
          render: (_, record) =>
            <div>
              <Tooltip title='Edit'>

                <Button
                  icon={<AiOutlineEdit />}
                  style={{ marginRight: 5 }}
                  onClick={() => this.triggerShowEditBOModal(record)}
                />
              </Tooltip>
              <Popconfirm
                title="Are you sure you want to delete?"
                onConfirm={() => this.deleteNewBo(record)}
              >
                <Tooltip title='Delete'>
                  <Button icon={<AiOutlineDelete />} />
                </Tooltip>
              </Popconfirm>
            </div>

        },
      ],
      defaultBOData: [],
      showNewBOModal: false,
      showEditBOModal: false,
      tempBOToEdit: {},
      tempBoToDelete: {},
      response: {},
      isDisablePercentageInterest: false,
      // loaders
      isAddingNewBoLoader: false,
      isSubmittingForm: false,
    }
  }

  onSubmitForm = async (values) => {
    await this.setState({
      isSubmittingForm: true,
      response: {
        formValues: values,
        formBOs: this.state.defaultBOData
      }
    })

    await submitForm(this.state.response)

    await this.setState({
      isSubmittingForm: false,
      defaultBOData: []
    })
    this.childBOFOrm.current.BOFOrm.current.resetFields()
    message.success({
      content: 'Submitted successfully',
      style: {
        position: 'absolute',
        right: '2%',
      },
    });
  };

  onSubmitFormFailed = async (errorInfo) => {
    message.error('Please fill in all mandatory fields!')
  };

  triggerShowNewBOModal = async () => {
    await this.setState({
      isDisablePercentageInterest: this.childBOFOrm.current.BOFOrm.current.getFieldValue('eis3PersonBoType') === 'val1' ? false : true,
      showNewBOModal: !this.state.showNewBOModal
    })
  }

  resetBOTable = async () => {
    await this.setState({
      defaultBOData: []
    })
  }

  addNewBO = async (values) => {
    await this.setState({
      isAddingNewBoLoader: true,
      isLoadingBOTable: true
    })
    await this.setState({
      defaultBOData: [...this.state.defaultBOData, {
        key: uuidv4(),
        boSurname: values.newBOSurname,
        boFirstName: values.newBOFirstName,
        boNIC: values.newBONIC,
        boNICProof: values.newBONICProof.fileList,
        boNationality: values.newBONationality,
        boAddress: values.newBOAddress,
        boAddressProof: values.newBOAddressProof.fileList,
        boInterestPercent: values.newBOInterestPercent,
      }]
    })
    await this.setState({
      showNewBOModal: false,
      isAddingNewBoLoader: false,
      isLoadingBOTable: false,
    })

    console.log(values);
    console.log(this.state.defaultBOData);
  }

  triggerShowEditBOModal = async (boToEdit) => {
    console.log(boToEdit, 9)
    await this.setState({
      tempBOToEdit: boToEdit,
      isDisablePercentageInterest: this.childBOFOrm.current.BOFOrm.current.getFieldValue('eis3PersonBoType') === 'val1' ? false : true,
      showEditBOModal: !this.state.showEditBOModal
    })
  }

  editNewBO = async (values) => {
    await this.setState({
      isEdittingNewBoLoader: true,
      isLoadingBOTable: true
    })
    console.log(values, 99)
    let defaultBOData = [...this.state.defaultBOData];
    let itemIndex = defaultBOData.findIndex(x => x.key === this.state.tempBOToEdit.key)
    let item = { ...defaultBOData[itemIndex] };
    item.boSurname = values.newBOSurname
    item.boFirstName = values.newBOFirstName
    item.boNIC = values.newBONIC
    // item.boNICProof = values.newBONICProof.fileList
    item.boNICProof = values.newBONICProof.fileList ? values.newBONICProof.fileList : [values.newBONICProof[0]]
    item.boNationality = values.newBONationality
    item.boAddress = values.newBOAddress
    item.boAddressProof = values.newBOAddressProof.fileList ? values.newBOAddressProof.fileList : [values.newBOAddressProof[0]]
    // item.boAddressProof = values.newBOAddressProof.fileList
    item.boInterestPercent = values.newBOInterestPercent
    defaultBOData[itemIndex] = item;

    await this.setState({ defaultBOData });
    await this.setState({
      showEditBOModal: false,
      isEdittingNewBoLoader: false,
      isLoadingBOTable: false,
    })
  }

  deleteNewBo = async (boToDelete) => {
    let defaultBOData = [...this.state.defaultBOData];
    let itemIndex = defaultBOData.findIndex(x => x.key === boToDelete.key)
    defaultBOData.splice(itemIndex, 1)
    await this.setState({ defaultBOData })
  }

  render() {
    return (
      <Layout style={{ height: '100%', minHeight: '100vh' }}>
        <Content
          className="site-layout-background"
          style={{
            margin: 0,
            padding: 14,
            minHeight: 280,
            background: 'transparent'
          }}
        >
          <Row>
            <Col xs={0} sm={0} md={0} lg={5}></Col>
            <Col xs={24} sm={24} md={24} lg={15}>
              <BOForm
                {...this.state}
                ref={this.childBOFOrm}
                triggerShowNewBOModal={this.triggerShowNewBOModal.bind(this)}
                triggerShowEditBOModal={this.triggerShowEditBOModal.bind(this)}
                resetBOTable={this.resetBOTable.bind(this)}
                onSubmitForm={this.onSubmitForm.bind(this)}
                onSubmitFormFailed={this.onSubmitFormFailed.bind(this)}
              />
            </Col>
            <NewBOModal
              {...this.state}
              addNewBO={this.addNewBO.bind(this)}
              triggerShowNewBOModal={this.triggerShowNewBOModal.bind(this)}
            />
            <EditBOModal
              {...this.state}
              editNewBO={this.editNewBO.bind(this)}
              triggerShowEditBOModal={this.triggerShowEditBOModal.bind(this)}
            />
            <Col xs={0} sm={0} md={0} lg={5}></Col>
          </Row>
        </Content>
      </Layout >

    );
  }
}

export default App;
